import basicQuestionStylesHtmlMessages from './basic-styles.jsx';
import bubbleQuestionStylesHtmlMessages from './bubble.jsx';

const QUESTION_STYLE_MSG_KEYS = {
    basic: 'basic',
    bubble: 'bubble'
}

const getQuestionStyles = styleKey => {
    switch (styleKey) {
        case QUESTION_STYLE_MSG_KEYS.bubble:
            return bubbleQuestionStylesHtmlMessages
        default:
            return basicQuestionStylesHtmlMessages
    }
};

export {
    getQuestionStyles,
    QUESTION_STYLE_MSG_KEYS
}
